module.exports = global["jQuery"] = require("-!/home/teamcity/agent/rg-linuxbuildphy01.red-gate.com-01/work/cc8f03c7c6cae775/RedGate.SqlClone.Client.Web/node_modules/expose-loader/index.js?$!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js
// module id = 1048
// module chunks = 0